import { LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE } from "../Constants";

export const Login = (payload) => ({
    type: LOGIN,
    payload
});

export const LoginSuccess = (payload) => ({
    type: LOGIN_SUCCESS,
    payload
});

export const LoginFailure = (payload) => ({
    type: LOGIN_FAILURE,
    payload
});